module.exports = new __parcel__URL__("magnifying_glass.8bd2cc78.svg").toString();